let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ffDKI")).then(() => parcelRequire('eZ0lf'));